var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReplay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 313,
    viewBox: "0 0 288 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_638_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.27 50.95C166.88 55.46 171.58 59.88 176.06 64.51C179.81 68.38 180.52 73.12 178.4 77.6C176.19 82.27 171.6 85.32 166.68 84.54C164.13 84.14 161.27 82.94 159.46 81.18C147.29 69.35 135.29 57.36 123.41 45.25C117.57 39.29 118.52 30.17 125.49 25.38C136.9 17.54 148.43 9.89001 160.04 2.35001C166.18 -1.63999 172.92 -0.429987 176.64 4.90001C180.84 10.91 179.69 17.78 173.75 22.32C171.91 23.72 170.13 25.19 168.09 26.8C175.76 28.98 183.11 30.49 190.03 33.11C245.36 54.1 278.75 93.61 286.26 152.47C295.83 227.49 242.52 297.51 168.03 310.1C89.6199 323.38 14.7899 271.21 2.24991 192.75C-7.33009 132.87 13.7599 84.87 63.7999 49.96C67.9199 47.08 71.7899 44.84 76.8199 47.41C84.7499 51.46 85.6599 62.29 78.2499 67.49C66.0999 76.02 55.4699 86.04 46.6499 98.02C-0.640091 162.25 28.9699 256.27 104.56 281.69C173.42 304.84 245.66 263.81 260.96 192.85C274.47 130.17 233.45 66.29 170.36 51.78C167.85 51.2 165.32 50.72 162.8 50.2C162.62 50.45 162.45 50.7 162.27 50.95Z",
    fill: "#A7F3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0296 168.18C98.0296 151.97 98.0496 135.77 98.0196 119.56C98.0096 115.66 98.9596 112.18 101.81 109.36C106.16 105.04 111.05 104.49 116.76 107.9C137.82 120.5 158.86 133.13 179.9 145.76C186.1 149.48 192.32 153.15 198.48 156.91C208.53 163.05 208.53 174.16 198.4 180.25C171.4 196.5 144.38 212.72 117.32 228.88C108.47 234.17 98.0596 229.17 98.0396 218.3C98.0196 205.96 98.0296 193.62 98.0296 181.27C98.0296 176.9 98.0296 172.54 98.0296 168.18Z",
    fill: "#A7F3F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_638_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 287.36,
    height: 312.18,
    fill: "#A7F3F4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay);
export default __webpack_public_path__ + "static/media/replay.a42d7e500664c48daf9fd830652a3580.svg";
export { ForwardRef as ReactComponent };